export const SHOW_MODAL = 'MODAL/SHOW_MODAL'
export const HIDE_MODAL = 'MODAL/HIDE_MODAL'
export const HIDE_ALL_MODAL = 'MODAL/HIDE_ALL_MODAL'
